<app-toolbar></app-toolbar>
<div class="router_outlet">
<router-outlet ></router-outlet>
</div>
<div class = "bottom-fixed-component">
    <app-footer></app-footer>
</div>


